import { Event, SDK, ServerOptions } from '@commercetools/frontend-sdk';
import { RegisterBusinessUnitAction } from '../../types/actions/BusinessUnitActions';
import { ComposableCommerceEvents } from '../../types/events/ComposableCommerceEvents';
import { RegisterBusinessUnitPayload } from 'sdk/composable-commerce/types/payloads/BusinessUnitPayloads';
import { Account } from 'types/entity/account';

export type BusinessUnitActions = {
  registerBusinessUnit: RegisterBusinessUnitAction;
};

export const getBusinessUnitActions = (sdk: SDK<ComposableCommerceEvents>): BusinessUnitActions => {
  return {
    registerBusinessUnit: async (
      payload: RegisterBusinessUnitPayload,
      options: {
        parallel?: boolean;
        customHeaderValue?: string;
        serverOptions?: ServerOptions;
      } = {},
    ) => {
      const response = await sdk.callAction<Account>({
        actionName: 'businessUnit/registerBusinessUnit',
        payload,
        parallel: options.parallel,
        customHeaderValue: options.customHeaderValue,
        serverOptions: options.serverOptions,
      });

      if (!response.isError) {
        const account = response.data;
        if (account) {
          sdk.trigger(
            new Event({
              eventName: 'businessUnitRequested',
              data: {
                account,
              },
            }),
          );
        }
      }
      return response;
    },
  };
};
